import { CSSProperties, PropsWithChildren } from 'react';

import styled from '@emotion/styled';

type FlexProps = {
  columnGap?: number;
  rowGap?: number;
  gap?: number;
  isExpanded?: boolean;
  direction?: 'row' | 'column' | 'column-reverse' | 'row-reverse';
  justify?: 'center' | 'flex-start' | 'flex-end' | 'space-around' | 'space-between';
  align?: 'center' | 'flex-start' | 'flex-end' | 'stretch';
  className?: string; // styled-components className
  flexWrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
  style?: CSSProperties;
};

const Flex = ({
  children,
  columnGap = 0,
  rowGap = 0,
  gap = 0,
  isExpanded = false,
  direction = 'row',
  align,
  justify,
  className,
  flexWrap = 'nowrap',
  style,
}: PropsWithChildren<FlexProps>) => {
  return (
    <SFlexWrapper
      $columnGap={columnGap}
      $rowGap={rowGap}
      $gap={gap}
      $isExpanded={isExpanded}
      $direction={direction}
      $align={align}
      $justify={justify}
      $flexWrap={flexWrap}
      className={className}
      style={style}
    >
      {children}
    </SFlexWrapper>
  );
};

type SFlexWrapperProps = {
  $columnGap: number;
  $rowGap: number;
  $gap: number;
  $isExpanded: boolean;
  $direction: 'row' | 'column' | 'column-reverse' | 'row-reverse';
  $justify?: 'center' | 'flex-start' | 'flex-end' | 'space-around' | 'space-between';
  $align?: 'center' | 'flex-start' | 'flex-end' | 'stretch';
  $flexWrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
};
const SFlexWrapper = styled.div<SFlexWrapperProps>`
  display: flex;
  flex-direction: ${(props) => props.$direction};
  column-gap: ${(props) => `${props.$columnGap}px`};
  row-gap: ${(props) => `${props.$rowGap}px`};
  flex-wrap: ${(props) => props.$flexWrap};
  ${(props) => props.$gap > 0 && `gap: ${props.$gap}px;`};
  ${({ $isExpanded }) =>
    $isExpanded &&
    `
      flex: 1;
    `};
  ${({ $justify }) => `${$justify ? `justify-content: ${$justify}` : ''}`};
  ${({ $align }) => `${$align ? `align-items: ${$align}` : ''}`};
`;

export default Flex;
